import { pickBy, debounce, nth } from 'lodash';
import GLOBAL_FILTER_BUS, { EVENTS } from '../../modules/global-filters/bus';

export default {
  data() {
    return {
      pagination: {
        search: '',
        currentPage: 1,
        pageSize: 100,
        sort: '',
        order: ''
      },
      paginationOptions: {
        pageSizes: [100, 200, 300, 400],
        layout: 'total, sizes, prev, slot, next'
      },
      timeout: null
    };
  },
  beforeDestroy() {
    GLOBAL_FILTER_BUS.$off(EVENTS.FORM_SUBMIT, this.handleGlobalFilterFormSubmitting);
  },
  mounted() {
    GLOBAL_FILTER_BUS.$on(EVENTS.FORM_SUBMIT, this.handleGlobalFilterFormSubmitting);
  },
  computed: {
    getDefaultSort() {
      const order = this.pagination.order === 'asc' ? 'ascending' : 'descending';

      return { prop: this.pagination.sort, order };
    },
    getQuery() {
      const {
        pageSize, currentPage, search, sort, order
      } = this.pagination;
      const offset = (pageSize * currentPage) - pageSize;
      const dirtyQuery = {
        offset, limit: pageSize, search, sort, order
      };

      return pickBy(dirtyQuery, v => v !== null && v !== undefined && v !== '');
    }
  },
  methods: {
    handleGlobalFilterFormSubmitting() {
      this.pagination.currentPage = 1;
    },
    handlePrevNext(c) {
      this.pagination.currentPage = c;
      this.fetchData();
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    handleVirtualScroll() {
      this.pagination.currentPage += 1;
      this.fetchData();
    },
    onFilter: debounce(function debounced(search) {
      this.pagination.search = search;
      this.pagination.currentPage = 1;
      this.fetchData();
    }, 500),
    onSortChange({ prop, order }) {
      const sortProp = nth(prop.split('.'), 0);
      // stats.XXXX şeklinde yapılan sort işleminde elasticSearch tarafından hata alınıyor
      if (sortProp !== 'stats') {
        this.pagination.sort = prop;
        this.pagination.order = order === 'descending' ? 'desc' : 'asc';

        this.pagination.currentPage = 1;

        this.fetchData();
      }
    }
  }
};
